import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import FeedbackFaces from '../../components/FeedbackFaces';
import VerbButton from '../../../shared/components/VerbButton';
import SleekLoadingIndicator from '../../../shared/components/SleekLoadingIndicator';
import { RuntimeContext } from '../../../../common/RuntimeContext';

const FeedbackModule = (props) => {
    const config = useContext(RuntimeContext);
    const {
        updateProfile,
        userProfile,
        handleFeedbackClose,
        userCompany,
        postUserFeedback,
        handleFeedbackExtended
    } = props;

    const [faceNumber, setFaceNumber] = useState();
    const [textInput, setTextInput] = useState('');
    const [emailPermission, setEmailPermission] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [checkMark, setCheckMark] = useState(false);
    const [closeAnimation, setCloseAnimaton] = useState(false);

    const handleFaceClick = (index) => {
        if (index === faceNumber) {
            setFaceNumber();
            handleFeedbackExtended(false);
        } else {
            setFaceNumber(index);
            handleFeedbackExtended(true);
        }
    };

    const updateProfileSubmit = () => {
        updateProfile({
            id: userProfile._id,
            profile: {
                ...userProfile,
                feedbackClosedOrSubmited: new Date(Date.now()).toISOString()
            },
            isLoggedInUser: true,
            pathsContext: config.pathsWeb
        });
    };

    const handleSubmit = () => {
        setIsLoading(true);
        postUserFeedback({
            body: {
                userEmail: userProfile.email,
                userCompanyId: userCompany._id,
                userProfileId: userProfile._id,
                feedbackValue: faceNumber,
                feedbackMessage: textInput,
                followUpPerm: emailPermission
            },
            pathsContext: config.pathsWeb
        }).then(() => {
            updateProfileSubmit();
            setIsLoading(false);
            setCheckMark(true);
            setTimeout(() => {
                setCloseAnimaton(true);
            }, '100');
            setTimeout(() => {
                handleFeedbackClose();
                handleFeedbackExtended(false);
            }, '680');
        });
    };

    return (
        <div className={`home-feedback-module`}>
            <div className={`faces-main-container ${closeAnimation ? 'hide-faces' : 'show-faces'}`}>
                <div className={'close-container'}>
                    <i
                        className={'fal fa-times'}
                        onClick={() => {
                            updateProfileSubmit();
                            setTimeout(() => {
                                setCloseAnimaton(true);
                            }, '100');
                            setTimeout(() => {
                                handleFeedbackClose();
                                handleFeedbackExtended(false);
                            }, '680');
                        }}
                    />
                </div>
                <div className={`container`}>
                    <div className={'row'}>
                        <div className={'col-12 col-md-6 how-verb-text-container'}>
                            <div className={'how-verb-text'}>How has your Verb experience been?</div>
                        </div>
                        <div className={'col-12 col-md-6'}>
                            <div className={'row'}>
                                <FeedbackFaces handleFaceClick={handleFaceClick} faceNumber={faceNumber} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container more-input ${faceNumber ? 'show' : 'hide'}`}>
                    <div className={'row'}>
                        <form className={'col-12'}>
                            <div className={'form-group text-area-more'}>
                                <label htmlFor={'tell-us-more-form'} className={'tell-us-more-form mx-auto'}>
                                    Please tell us more.
                                </label>
                                <textarea
                                    className={'form-control'}
                                    id={'tell-us-more-form'}
                                    rows={'3'}
                                    onChange={(e) => setTextInput(e.target.value)}
                                ></textarea>
                            </div>
                            <div className={'row'}>
                                <label className={'form-check-label col-12 col-sm-9'}>
                                    May we follow-up with you via email regarding your feedback?
                                </label>
                                <div className={'form-check feedback-radio-wrapper'}>
                                    <div className={'row'}>
                                        <div className={'radio'}>
                                            <input
                                                id={'email-permission-radio-yes'}
                                                name={'radio'}
                                                type={'radio'}
                                                onClick={() => setEmailPermission(true)}
                                            />
                                            <label htmlFor={'email-permission-radio-yes'} className={'radio-label'}>
                                                Yes
                                            </label>
                                        </div>
                                        <div className={'radio'}>
                                            <input
                                                id={'email-permission-radio-no'}
                                                name={'radio'}
                                                type={'radio'}
                                                onClick={() => setEmailPermission(false)}
                                            />
                                            <label htmlFor={'email-permission-radio-no'} className={'radio-label'}>
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {isLoading ? (
                                <div className={'loading-indicator-container mx-auto'}>
                                    <SleekLoadingIndicator />
                                </div>
                            ) : (
                                <VerbButton
                                    disabled={emailPermission === undefined || !textInput.length}
                                    className={checkMark ? 'check-mark-inside mx-auto' : 'mx-auto'}
                                    onClick={handleSubmit}
                                >
                                    {checkMark ? <div className={'check-mark'}></div> : 'SUBMIT'}
                                </VerbButton>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

FeedbackModule.propTypes = {
    postUserFeedback: PropTypes.func,
    updateProfile: PropTypes.func,
    userProfile: PropTypes.object,
    handleFeedbackClose: PropTypes.func,
    handleFeedbackExtended: PropTypes.func,
    userCompany: PropTypes.object
};

export default FeedbackModule;
